import { App as AntApp } from 'antd';
import { type ReactNode, StrictMode, useContext } from 'react';
import { RouterProvider } from 'react-router-dom';
import './app.css';
import GlobalDownloadIndicator from './components/global-download-indicator';
import AuthContextProvider, { AuthContext } from './contexts/auth-context-provider';
import { CartContextProvider } from './contexts/cart.context';
import { DownloadProvider } from './contexts/global-download-context-provider';
import useRouter from './hooks/use-router';
import { JsonApiProvider } from './jsonapi-provider';
import ShadcnUiTheme from './themes/shadcn-ui';

const JsonApiProviderRegistrar = ({ children }: { children: ReactNode }): ReactNode => {
  const { isAuthenticated, session } = useContext(AuthContext);

  return (
    <JsonApiProvider
      baseUrl={process.env.REACT_APP_API_BASE_URL}
      accessToken={isAuthenticated ? session?.accessToken : undefined}
    >
      {children}
    </JsonApiProvider>
  );
};

function App(): ReactNode {
  const router = useRouter();

  return (
    <StrictMode>
      <AuthContextProvider>
        <ShadcnUiTheme>
          <DownloadProvider>
            <JsonApiProviderRegistrar>
              <AntApp notification={{ placement: 'bottomRight' }}>
                <CartContextProvider>
                  <RouterProvider router={router} />
                </CartContextProvider>
                <GlobalDownloadIndicator />
              </AntApp>
            </JsonApiProviderRegistrar>
          </DownloadProvider>
        </ShadcnUiTheme>
      </AuthContextProvider>
    </StrictMode>
  );
}

export default App;
